import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/oppgaver',
    name: 'Oppgaver',
    component: () => import('./views/Oppgaver.vue')
  }
]

export default routes
